import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { DeviceCreatableInterface } from '../interfaces/device-creatable.interface';
import { DeviceDto } from './device.dto';

export class DeviceCreateDto
  extends IntersectionType(
    PickType(DeviceDto, ['deviceType', 'fcmToken', 'userId']),
    PartialType(PickType(DeviceDto, ['deviceToken'])),
  )
  implements DeviceCreatableInterface {}
